/**
 * Official UTMify tracking script loader.
 * Injects the UTMify UTM script once, on the client only.
 */

const UTMIFY_SCRIPT_SRC = 'https://cdn.utmify.com.br/scripts/utms/latest.js';

export function loadUtmify(): void {
  if (typeof document === 'undefined') return;
  if (document.querySelector(`script[src="${UTMIFY_SCRIPT_SRC}"]`)) return;

  const script = document.createElement('script');
  script.src = UTMIFY_SCRIPT_SRC;
  script.setAttribute('data-utmify-prevent-xcod-sck', '');
  script.setAttribute('data-utmify-prevent-subids', '');
  script.async = true;
  script.defer = true;

  document.head.appendChild(script);
}
